import axios from "axios"
import {CONTENT_API_URL} from "../../config"
import logger from "../../services/logger"

const SUPPORTED = ["en", "fr", "he", "it", "ru", "de", "pt", "es"]
const FALLBACK = "en"

function siteOf(langValue) {
    const lang = (langValue || "").toLowerCase().split("-")[0]
    return SUPPORTED.includes(lang) ? lang : FALLBACK
}

const http = axios.create({baseURL: CONTENT_API_URL, timeout: 8000})

const ApiClient = {
    siteOf,

    async getCategories(langValue) {
        try {
            const site = siteOf(langValue)
            const res = await http.get(`/v1/${site}/categories`)
            return {site, items: res.data || []}
        } catch (e) {
            logger.error({ err: e }, "ContentHub API getCategories error")
            return {site: siteOf(langValue), items: []}
        }
    },

    async listArticles({langValue, page = 1, perPage = 12, categoryAid = null, q = null}) {
        try {
            const site = siteOf(langValue)
            const params = {page, per_page: perPage}
            if (categoryAid != null && categoryAid !== "") params.category_aid = categoryAid
            if (q != null && String(q).trim() !== "") params.q = String(q).trim()
            const res = await http.get(`/v1/${site}/articles`, {params})
            return {site, ...(res.data || {})}
        } catch (e) {
            logger.error({ err: e }, "ContentHub API listArticles error")
            return {site: siteOf(langValue), total: 0, items: []}
        }
    },
}

export default ApiClient
